import {Children, Fragment, isValidElement, ReactElement, ReactNode} from 'react';

type FlattenedReactElementProps = {
  children?: ReactNode;
  isLastChild?: boolean;
};

export function flattenReactNode(
  children: ReactNode
): Array<ReactElement<FlattenedReactElementProps>> {
  const array: Array<ReactElement<FlattenedReactElementProps>> = [];
  flattenReactNodeInto(array, children);
  return array;
}

function flattenReactNodeInto(
  target: Array<ReactElement<FlattenedReactElementProps>>,
  children: ReactNode
) {
  Children.forEach(children, (child) => {
    if (isValidElement<FlattenedReactElementProps>(child)) {
      if (child.type === Fragment) {
        flattenReactNodeInto(target, child.props.children);
      } else {
        target.push(child);
      }
    }
  });
}
